











































































































































































import { Component, Mixins } from 'vue-property-decorator';
import { Auth } from '@aws-amplify/auth';
import { Profile } from '@/api/model';
import MessageToastMixin from '@/mixins/MessageToastMixin';
import FormGroup from '@/components/profile/FormGroup.vue';
import { Languages } from '@/logic/locale/Languages';

@Component({
  components: { FormGroup },
})
export default class ProfileForm extends Mixins(MessageToastMixin) {
  formGroups: any = {
    profile: {
      active: false,
      fields: [
        { name: 'firstName' },
        { name: 'lastName' },
        { name: 'functionTitle' },
        { name: 'city' },
        { name: 'country', type: 'country' },
        { name: 'phone' },
      ],
    },
    email: {
      active: false,
      fields: [{ name: 'email', type: 'email' }],
    },
    password: {
      active: false,
      fields: [
        { name: 'oldPassword', type: 'password' },
        { name: 'newPassword', type: 'password' },
        { name: 'newPasswordRepeat', type: 'password' },
      ],
    },
    locale: {
      active: false,
      fields: [{ name: 'locale', type: 'locale' }],
    },
  };

  get profile(): Profile {
    return this.$store.state.profile.profile;
  }

  get fullName(): string {
    const { firstName, lastName } = this.profile;
    const first = firstName || '';
    const last = lastName || '';
    const space = first && last ? ' ' : '';
    return `${first}${space}${last}`;
  }

  getLanguage(code: string) {
    return Languages.getLanguageById(code);
  }

  edit(formGroup: string) {
    this.formGroups[formGroup].active = true;
    Object.keys(this.formGroups)
      .filter((group) => group !== formGroup)
      .forEach((group) => {
        this.formGroups[group].active = false;
      });
  }

  cancel(formGroup: string) {
    this.formGroups[formGroup].active = false;
  }

  // @todo loader
  async save(formGroup: string) {
    const group = this.formGroups[formGroup];
    const newFields: any = {};
    group.fields.forEach((f: any) => {
      if (f.value !== undefined) {
        newFields[f.name] = f.value;
      }
    });
    const newProfile = Object.assign(this.profile, newFields);

    // Sync to cognito
    const cognitoGroups = ['email', 'password', 'locale'];
    if (cognitoGroups.includes(formGroup)) {
      const user = await Auth.currentAuthenticatedUser();

      try {
        // Password
        if (formGroup === 'password') {
          const success = await this.savePassword(newFields, user);
          if (!success) {
            return;
          }
        } else {
          this.saveAttributes(newFields, user, formGroup);
        }
      } catch (e) {
        this.showError(this.$t('profile.password.invalid'));
        return;
      }
    }

    // Sync to aws database
    try {
      if (formGroup !== 'password') {
        await this.$store.dispatch('profile/saveProfile', newProfile);
      }
      group.active = false;
      this.showSuccess(this.$t('profile.error.success'));
    } catch (e) {
      this.showError(this.$t('profile.error.failed'));
    }
  }

  setField(formGroup: string, fieldName: string, value: string) {
    const field = this.formGroups[formGroup].fields.find(
      (f: any) => f.name === fieldName,
    );
    field.value = value;
  }

  async savePassword(fields: any, user: any): Promise<boolean> {
    if (fields.newPassword !== fields.newPasswordRepeat) {
      this.showError(this.$t('profile.password.do-not-match'));
      return false;
    }
    await Auth.changePassword(user, fields.oldPassword, fields.newPassword);
    this.showSuccess(this.$t('profile.password.change-success'));
    return true;
  }

  saveAttributes(fields: any, user: any, formGroup: string) {
    const { attributes } = user;

    // Only sync existing fields
    const newAttributes: any = {};
    if (fields.email && attributes.email !== fields.email) {
      newAttributes.email = fields.email;
    }
    if (fields.phone && attributes.phone !== fields.phone) {
      newAttributes.phone = fields.phone;
    }
    if (fields.locale && attributes.locale !== fields.locale) {
      newAttributes.locale = fields.locale;
    }

    Auth.updateUserAttributes(user, newAttributes);

    if (formGroup === 'email') {
      this.showEmailConfirm();
    }

    if (formGroup === 'locale') {
      this.showSuccess(this.$t('profile.locale.change-success'));
    }
  }

  async showEmailConfirm() {
    await this.$buefy.dialog.prompt({
      message: this.$t('profile.email.confirmation-code') as string,
      inputAttrs: {
        type: 'text',
        placeholder: this.$t('profile.placeholder.confirmation-code'),
        value: '',
      },
      confirmText: this.$t('profile.label.save') as string,
      canCancel: false,
      trapFocus: true,
      closeOnConfirm: false,
      onConfirm: (code, { close }) => this.confirmEmail(code, close),
    });
  }

  // If email changed, show input popup message for confirmation mail code
  async confirmEmail(code: string, close: () => void) {
    try {
      await Auth.verifyCurrentUserAttributeSubmit('email', code);
      this.showSuccess(this.$t('profile.email.confirmed'));
      close();
    } catch (e) {
      this.showError(this.$t('profile.email.error-confirm-code'));
    }
  }
}
